import React from 'react';
import './About.css';
import church1 from '../Images/church-1.jpg';


function About() {
    return (
        <div className="about">
            <div className="aboutInfo">
                <div className="aboutInfo__header">
                <img src={church1} alt=""/>
                    <h3>Let's worship together at Muthetheni</h3>
                </div>
                <div className="aboutInfo__story">
                    <h3>About us</h3>
                    <div className="story">
                        <p>Muthetheni AIC is an African Inland Church located on the out skirts of Muthetheni Town.</p>
                        <p>The church is a branch of Kithianio AIC. It started in the year 2014 at sunshine academy</p>
                    </div>
                    <div className="mission">
                        <h3>Our Mission</h3>
                        <p>Our mission is to reach out to the world through evangelism via arts, drama, and theater in general by being the custodian of all practical applied art, drama, skit and stage evangelism as a practical ministry unto Almighty God</p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default About
